import { TransferStatusTypes } from "manifest-components/src/classes/transfer";
import { TransferActions } from "manifest-components/src/classes/transferInstruction";

export const DevelopmentEnvironmentState = {
  showMenu: false,
  showLocationState: false,
  displayOneTimeCode: false,
  displayRestartTransfer: false,
  transferInputReasonOverride: "" as TransferActions | "",
  transferStatusOveride: "" as TransferStatusTypes | "",
};
